"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

var _jsxruntime = require('react/jsx-runtime');

var t = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "ArrowLeftIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M16.237 23.8571L17.0325 23.0523C17.2208 22.8618 17.2208 22.553 17.0325 22.3625L10.7996 16.0568H24.5179C24.7841 16.0568 25 15.8384 25 15.5691V14.4309C25 14.1615 24.7841 13.9431 24.5179 13.9431H10.7996L17.0325 7.63744C17.2208 7.44696 17.2208 7.13812 17.0325 6.9476L16.237 6.14286C16.0488 5.95238 15.7435 5.95238 15.5552 6.14286L7.14121 14.6551C6.95293 14.8456 6.95293 15.1544 7.14121 15.3449L15.5552 23.8571C15.7434 24.0476 16.0487 24.0476 16.237 23.8571Z"
  }),
  svgElements: ["path"]
});

exports.a = t;